export default __webpack_public_path__ + "static/white-claw-website-wave-cinemagraph-3dba78aec30fa493a264e49ae5e8a713.mp4";